import { useMutation } from '@tanstack/react-query';
import { deleteApi } from '../../api/client';
import queryClient from '../../config/queryClient';
import { STUDENTS_LIST_KEY } from './useStudentsLists.hooks';

export const useRemoveStudent = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => unknown;
  onError: (error: any) => unknown;
}) =>
  useMutation(
    ({ studentId }: { studentId: number }) =>
      deleteApi(`api/v1/students/${studentId}/remove`),
    {
      onSuccess: () => {
        onSuccess();
        queryClient.invalidateQueries({
          //   queryKey: [STUDENTS_LIST_KEY.STUDENTS_LIST],
          queryKey: [STUDENTS_LIST_KEY.STUDENTS_LIST],
        });
      },
      onError: (error: any) => {
        onError(error);
      },
    }
  );
